module.exports = __webpack_public_path__ + "static/media/feature-slideg6.05eed28c.jpg";